import React, {PropTypes, Component} from 'react'
import moment from 'moment'
import locale from './locale'

class AttendanceStatus extends Component {
  constructor(props){
    super(props)
  }

  static propTypes = {
    attendenceInfo: PropTypes.object.isRequired
  }

  renderStatus(){
    let { attendenceInfo, currentRole } = this.props
    let {check_in_state, lesson_start_datetime, lesson_end_datetime, check_in_datetime} = attendenceInfo
    if(check_in_state == 0){
      if(currentRole === 'student'){
        return __('Unchecked', locale)
      }else {
        return __('Absent (without notice)', locale)
      }
    }else if(check_in_state == 1){
      if(moment(check_in_datetime).isBefore(lesson_start_datetime)){
        return __('Attended', locale);
      }else if ((moment(check_in_datetime).isBetween(moment(lesson_start_datetime), moment(lesson_end_datetime), null, '[]'))){
        return __('Late', locale);
      }else {
        return __('Make Up', locale);
      }
    } else if (check_in_state == 2){
      return __('Absent (with excuse)', locale)
    } else if (check_in_state == 3){
      return __('Late', locale)
    } else if (check_in_state == 4){
      return __('Absent (without notice)', locale);
    } else if (check_in_state == 5){
      return __('Make Up', locale);
    }
  }

  render(){
    return(
      <div className='class-status'>
        {this.renderStatus()}
      </div>
    )
  }
}


export default (AttendanceStatus)



// WEBPACK FOOTER //
// ./src/containers/pages/Teacher/Attendance/AttendanceStatus.js